import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const OpenDownloadIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 27 27"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 27)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="2"
    >
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="m13.5 1v17.95" />
        <path d="m6.77 12.42 6.73 6.73 6.73-6.73" />
        <path d="m26 19.27v2.24c0 2.49-1.5 4.49-3.33 4.49h-18.34c-1.83 0-3.33-2-3.33-4.49v-2.24" />
      </g>
    </SVG>
  );
};
